/**
 * The xchange mark.
 *
 * The artwork is dark navy on transparency, so on a dark theme it is inverted
 * rather than redrawn: the shape stays exactly as designed and stays visible
 * whichever theme the person's Telegram is using.
 */
export function Logo({ height = 24 }: { height?: number }) {
  return (
    <img
      className="logo"
      src="/logo.png"
      alt="xchange"
      height={height}
      style={{ height, margin: '0 auto' }}
    />
  );
}
